const shimmerBg =
  'bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 bg-[length:200%_100%] animate-shimmer';

const LoadingSpinner = () => {
  return (
    <div
      className="min-h-screen pt-16"
      role="status"
      aria-label="Chargement de la page"
    >
      <span className="sr-only">Chargement…</span>

      <div className={`h-[50vh] ${shimmerBg}`} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="space-y-4 mb-12">
          <div className={`h-10 w-2/3 md:w-1/3 rounded ${shimmerBg}`} />
          <div className={`h-4 w-1/2 rounded ${shimmerBg}`} />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[0, 1, 2].map((i) => (
            <div key={i} className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className={`h-[28rem] ${shimmerBg}`} />
              <div className="p-8 space-y-4">
                <div className={`h-8 w-3/4 rounded ${shimmerBg}`} />
                <div className={`h-4 w-1/2 rounded ${shimmerBg}`} />
                <div className="space-y-2 pt-2">
                  <div className={`h-3 w-full rounded ${shimmerBg}`} />
                  <div className={`h-3 w-full rounded ${shimmerBg}`} />
                  <div className={`h-3 w-2/3 rounded ${shimmerBg}`} />
                </div>
                <div className={`h-12 w-full rounded-lg ${shimmerBg}`} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
